module.exports = __webpack_public_path__ + "img/Payment-Shield-Insurance1.b2812dab.png";